module.exports = "/static/assets/b2838fd316505dfed435317ef645bc96.png";